export default "__VITE_ASSET__Yi_U02rp__"